import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { getSortAndFilterOption, SortAndFilterDisplayField } from 'stores/adapters/bex-api/search/search-sort-filter-adapter';
import { getMatchingFilterOption } from './filter-utils';

export const getStarFilterInput = (searchCriteria: SearchCriteriaModel, sortAndFilterOptions: any): number[] | null => {
  if (searchCriteria.star) {
    const criteriaStars = searchCriteria.star.split(',');
    const starOptions = getSortAndFilterOption(SortAndFilterDisplayField.STAR, sortAndFilterOptions);

    if (starOptions) {
      return criteriaStars
        .map(star => {
          const matchingOption = getMatchingFilterOption(star, starOptions);

          return matchingOption && matchingOption.value ? matchingOption.value : null;
        })
        .filter(star => star !== null)
        .map(star => Number.parseInt(star));
    }
  }

  return null;
};
